module.exports = __webpack_public_path__ + "static/media/reply-arrow-icon.b8840fad.svg";